<div class="update-monthly-limit-dialog">
  <mat-dialog-content>
    <h3 class="header">Update Monthly Limit</h3>
      <currency-input [formControl]="formControl" title="Monthly Limit" [max]="maxValue"></currency-input>
    <div fxLayout="row" fxLayoutAlign="space-between center">
      <button mat-stroked-button (click)="onCancel($event)">Cancel</button>
      <button mat-flat-button [disabled]="!formControl.valid" (click)="onSubmit($event)">Submit</button>
    </div>
  </mat-dialog-content>
</div>
